var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2314,
    cy: 14.0766,
    r: 13.3408,
    fill: "#F9F9F9",
    stroke: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8281 17.7445L12.2582 6.60717",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22336 15.3289L9.06185 15.7499C10.6031 16.1027 11.9177 17.1024 12.6696 18.4933C13.4028 19.85 14.6724 20.836 16.1684 21.2106L17.8908 21.6414C18.1694 21.7114 18.4607 21.5881 18.6043 21.3393L22.2832 14.9673C22.3837 14.7925 22.3964 14.5807 22.3178 14.3951C22.2391 14.2094 22.078 14.0713 21.8825 14.0219L20.5162 13.6799C19.0202 13.3055 17.7505 12.3194 17.0174 10.9626C16.2654 9.57154 14.9507 8.57182 13.4093 8.21887L11.5712 7.79817L7.22336 15.3289Z",
    fill: "#FECC00",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6888 9.28069L12.1003 8.94534L10.4726 11.7162L15.0306 14.0882L16.4396 11.6675L16.0762 11.0958L15.7299 10.6228L15.1961 10.0811L14.4844 9.62251L13.6888 9.28069Z",
    fill: "#D50000",
    stroke: "#D50000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5764 20.2949L17.8924 20.6204L19.4344 17.8941L15.3733 15.4097L13.6683 18.2571L14.0237 18.7912L14.5198 19.2464L15.0056 19.6298L15.7415 20.0331L16.5764 20.2949Z",
    fill: "#D50000",
    stroke: "#D50000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffside);
export default __webpack_public_path__ + "static/media/offside.b99e2941b4f128d1e7545e3e678e2c4c.svg";
export { ForwardRef as ReactComponent };